"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPayoutPeriodIndexToDateRange = transformPayoutPeriodIndexToDateRange;
const utils_1 = require("@daytrip/utils");
const date_fns_1 = require("date-fns");
function transformPayoutPeriodIndexToDateRange(periodIndex, originDate = new Date()) {
    let periodDate = new Date(originDate);
    let isFirstHalf = periodDate.getDate() <= 15;
    // Here I'm unsing `parseInt` instead of `Math.floor` because latter
    // is working differently with negative and positive numbers.
    // For example, `Math.floor(-1.5) == -2` but `Math.floor(1.5) == 1`.
    //
    // Note the second parameter (10) stands for "return as decimal number".
    periodDate = (0, date_fns_1.addMonths)(periodDate, parseInt(`${periodIndex / 2}`, 10));
    // Here we check the remainder of division
    if (periodIndex % 2 < 0) {
        // For example, if `periodDate` date is 6 of March, we subtract
        // one month from it and switch `isFirstHalf` flag, so in the
        // end it the range would be 15-28 of February.
        if (isFirstHalf) {
            periodDate = (0, date_fns_1.subMonths)(periodDate, 1);
            isFirstHalf = false;
        }
        else {
            isFirstHalf = true;
        }
    }
    else if (periodIndex % 2 > 0) {
        if (!isFirstHalf) {
            periodDate = (0, date_fns_1.addMonths)(periodDate, 1);
            isFirstHalf = true;
        }
        else {
            isFirstHalf = false;
        }
    }
    let startAt = (0, date_fns_1.startOfDay)(new Date(periodDate));
    let endAt = (0, date_fns_1.endOfDay)(new Date(periodDate));
    if (isFirstHalf) {
        startAt = (0, date_fns_1.setDate)(startAt, 1);
        endAt = (0, date_fns_1.setDate)(endAt, 15);
    }
    else {
        startAt = (0, date_fns_1.setDate)(startAt, 16);
        endAt = (0, date_fns_1.endOfMonth)(endAt);
    }
    return {
        isYearless: false,
        startAt: (0, utils_1.zonedTimeToUtcOrDefault)(startAt, "UTC"),
        endAt: (0, utils_1.zonedTimeToUtcOrDefault)(endAt, "UTC"),
    };
}
//# sourceMappingURL=transformPayoutPeriodIndexToDateRange.js.map